import { configureStore, Middleware } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";
import rootReducer from "./reducers/rootReducer.ts";
import rootSaga from "./sagas/rootSaga.ts";

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger();

const middleware: Middleware[] = [
  sagaMiddleware as Middleware,
  logger as Middleware
];

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(...middleware)
});

sagaMiddleware.run(rootSaga);

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export const getState = () => store.getState();

export default store;
